import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/down.png'
import _imports_1 from '../../assets/performance/banner.png'
import _imports_2 from '../../assets/performance/banner3.png'
import _imports_3 from '../../assets/performance/footer.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-89ef1e0e")

_pushScopeId("data-v-89ef1e0e")
const _hoisted_1 = {
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_2 = { class: "testMain" }
const _hoisted_3 = { class: "fitter_title" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, " 删除 ", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 编辑 ")
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("发送报告")
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "按任务生成报告", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "手动生成报告", -1)
const _hoisted_13 = { style: {"display":"flex","justify-content":"space-between","margin-top":"10px"} }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, "清除缓存", -1)
const _hoisted_16 = { class: "dialogTitle" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("手动生成报告-按任务")
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "el-icon-message-solid" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("生成报告")
const _hoisted_20 = { class: "dialogTitle" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", null, "手动生成报告", -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode("生成报告")
const _hoisted_23 = {
  key: 0,
  class: "editRecipient"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加： ")
const _hoisted_25 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_27 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_29 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
const _hoisted_31 = /*#__PURE__*/_createVNode("span", null, "发送报告", -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_33 = {
  class: "versionGeneration versionGeneration2",
  style: {}
}
const _hoisted_34 = { class: "copyVal" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("复制数据")
const _hoisted_36 = { id: "perf_report" }
const _hoisted_37 = {
  key: 0,
  class: "spacName"
}
const _hoisted_38 = /*#__PURE__*/_createVNode("img", {
  class: "banner",
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_39 = {
  key: 1,
  class: "spacName"
}
const _hoisted_40 = /*#__PURE__*/_createVNode("img", {
  class: "banner",
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_41 = { class: "spacName" }
const _hoisted_42 = { class: "gameTable" }
const _hoisted_43 = {
  rowspan: 3,
  class: "gameIcon"
}
const _hoisted_44 = {
  colspan: 3,
  class: "game_name"
}
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" 安卓版本: ")
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" 测试时间: ")
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" 创建者: ")
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" 皮肤数量: ")
const _hoisted_49 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createTextVNode(" 测试内容: "),
  /*#__PURE__*/_createVNode("span", null, "大厅皮肤性能")
], -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createTextVNode(" 测试平台: "),
  /*#__PURE__*/_createVNode("span", null, "安卓")
], -1)
const _hoisted_51 = { style: {"margin-bottom":"20px"} }
const _hoisted_52 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("一、测试概括")
], -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("h6", null, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle spacName" }, "◆"),
  /*#__PURE__*/_createTextVNode("测试内容")
], -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("li", null, " 王者海外性能标准尚未确定，本轮测试需求只做数据采集，不做风险判断 ", -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("h6", null, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle spacName" }, "◆"),
  /*#__PURE__*/_createTextVNode("测试机型")
], -1)
const _hoisted_56 = { class: "gameTable1" }
const _hoisted_57 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, "档位"),
    /*#__PURE__*/_createVNode("td", null, "机型"),
    /*#__PURE__*/_createVNode("td", null, "系统版本"),
    /*#__PURE__*/_createVNode("td", null, "帧率设置"),
    /*#__PURE__*/_createVNode("td", null, "分辨率"),
    /*#__PURE__*/_createVNode("td", null, "相机高度"),
    /*#__PURE__*/_createVNode("td", null, "局外角色渲染")
  ])
], -1)
const _hoisted_58 = /*#__PURE__*/_createVNode("textarea", { id: "input" }, "这是幕后黑手", -1)
const _hoisted_59 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("三、详细机型测试数据")
], -1)
const _hoisted_60 = { style: {"color":"#2b64bb","font-weight":"bold"} }
const _hoisted_61 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" 数据链接：")
const _hoisted_63 = {
  style: {"margin-top":"8px"},
  class: "gameTable1"
}
const _hoisted_64 = { style: {"background":"#5d99d5"} }
const _hoisted_65 = /*#__PURE__*/_createVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode("div", _hoisted_3, [
                    _createVNode(_component_el_form, {
                      inline: true,
                      size: "mini",
                      class: "spacForm queryReport"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "报告名称" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.report_id,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.report_id = $event)),
                              placeholder: "请选择",
                              onChange: _ctx.change_name_search
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.nameList, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: 
                        item.report_name +
                        '-[' +
                        item.create_date.replace('T', ' ') +
                        ']'
                      ,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_popconfirm, {
                              onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleDelete())),
                              title: "确认删除该报告？",
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  style: {"margin-right":"10px"},
                                  size: "mini",
                                  type: "info",
                                  disabled: _ctx.get_is_super
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_4
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              class: "editBtn",
                              size: "mini",
                              onClick: _ctx.handleEdit
                            }, {
                              default: _withId(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_el_dialog, {
                              modelValue: _ctx.dialogFormVisible1,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialogFormVisible1 = $event))
                            }, {
                              footer: _withId(() => [
                                _createVNode("span", _hoisted_6, [
                                  _createVNode(_component_el_button, {
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogFormVisible1 = false))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_7
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _ctx.dialogFormVisible2
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_8
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ])
                              ]),
                              default: _withId(() => [
                                _withDirectives(_createVNode(_component_el_form, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_form_item, {
                                      class: "reportName",
                                      label: "报告名称",
                                      "label-width": _ctx.formLabelWidth
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_input, {
                                          class: "report-input",
                                          modelValue: _ctx.form1.name,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form1.name = $event)),
                                          autocomplete: "off",
                                          width: "500"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }, 8, ["label-width"])
                                  ]),
                                  _: 1
                                }, 512), [
                                  [_vShow, _ctx.dialogFormVisible1]
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.sendOut,
                              class: "down_img"
                            }, {
                              default: _withId(() => [
                                _hoisted_9,
                                _hoisted_10
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode("div", null, [
                      _createVNode(_component_el_button, {
                        size: "mini",
                        type: "primary",
                        onClick: _ctx.generateReportsManuallyByTask,
                        disabled: _ctx.get_is_super,
                        style: {"height":"28px"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_tooltip, {
                            effect: "dark",
                            content: "暂无管理员权限",
                            placement: "top",
                            disabled: !_ctx.get_is_super
                          }, {
                            default: _withId(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"]),
                      _createVNode(_component_el_button, {
                        size: "mini",
                        type: "primary",
                        onClick: _ctx.generateReportsManually,
                        disabled: _ctx.get_is_super,
                        style: {"height":"28px"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_tooltip, {
                            effect: "dark",
                            content: "暂无管理员权限",
                            placement: "top",
                            disabled: !_ctx.get_is_super
                          }, {
                            default: _withId(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"]),
                      _createVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createVNode(_component_el_button, {
                          size: "mini",
                          type: "primary",
                          onClick: _ctx.clear,
                          disabled: _ctx.get_is_super,
                          style: {"height":"28px","margin-left":"auto"}
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_tooltip, {
                              effect: "dark",
                              content: "暂无管理员权限",
                              placement: "top",
                              disabled: !_ctx.get_is_super
                            }, {
                              default: _withId(() => [
                                _hoisted_15
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled"])
                      ])
                    ])
                  ]),
                  _createVNode(_component_el_dialog, {
                    modelValue: _ctx.dialogFormVisibleByTask,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogFormVisibleByTask = $event)),
                    width: "790px"
                  }, {
                    title: _withId(() => [
                      _createVNode("div", _hoisted_16, [
                        _createVNode("span", null, [
                          _hoisted_17,
                          _createVNode(_component_el_tooltip, {
                            class: "item",
                            effect: "dark",
                            content: "如只选择测试任务, 则按照任务完成自动生成报告的逻辑生成一份报告",
                            placement: "top"
                          }, {
                            default: _withId(() => [
                              _hoisted_18
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_component_el_divider)
                      ])
                    ]),
                    footer: _withId(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.generateReportByTask,
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _hoisted_19
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        inline: true,
                        model: _ctx.generateReportVersion,
                        "label-position": "top",
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "对比任务" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.oldEdition,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.generateReportVersion.oldEdition = $event)),
                                id: "old_version",
                                placeholder: "请选择",
                                "collapse-tags": "",
                                "collapse-tags-tooltip": "",
                                multiple: ""
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.RecentTaskrecord, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "测试任务" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.newEdition,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.generateReportVersion.newEdition = $event)),
                                id: "new_version",
                                placeholder: "请选择",
                                "collapse-tags": "",
                                "collapse-tags-tooltip": "",
                                multiple: ""
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.RecentTaskrecord, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_dialog, {
                    modelValue: _ctx.dialogFormVisible,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.dialogFormVisible = $event)),
                    width: "790px"
                  }, {
                    title: _withId(() => [
                      _createVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createVNode(_component_el_divider)
                      ])
                    ]),
                    footer: _withId(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.generateReport,
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _hoisted_22
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        inline: true,
                        model: _ctx.generateReportVersion,
                        "label-position": "top",
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "旧版本" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.oldEdition,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.generateReportVersion.oldEdition = $event)),
                                id: "old_version",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "新版本" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.newEdition,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.generateReportVersion.newEdition = $event)),
                                id: "new_version",
                                placeholder: "请选择",
                                onChange: _ctx.selectVersion
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createVNode(_component_el_form_item, { label: "场景" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.scenetion,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.generateReportVersion.scenetion = $event)),
                                multiple: "",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_scene_version, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.scene_id_id,
                                      label: item.scene_id__chinese,
                                      value: item.scene_id_id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.localProject != 34 && _ctx.localProject != 40]
                          ])
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.edit)
                    ? (_openBlock(), _createBlock("div", _hoisted_23, [
                        _createVNode(_component_el_form, {
                          "label-position": "left",
                          "label-width": "100px",
                          model: _ctx.formMail,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "邮件标题" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.title,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.formMail.title = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件发件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _createTextVNode(" 指定的邮件发件人需要位于公司TOF发件人名单,否则无法发送邮件。默认邮件发件人" + _toDisplayString(_ctx.formMail.Sender), 1)
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.Sender,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.formMail.Sender = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件收件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _hoisted_24,
                                    _hoisted_25,
                                    _hoisted_26,
                                    _hoisted_27,
                                    _hoisted_28,
                                    _hoisted_29,
                                    _hoisted_30
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.addressee,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.formMail.addressee = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件抄送人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.CC_List,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.formMail.CC_List = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_popconfirm, {
                              title: "确认发送报告吗？",
                              onConfirm: _cache[17] || (_cache[17] = ($event: any) => (_ctx.save_report(false))),
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  disabled: _ctx.get_is_super,
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_31
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "info",
                              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.edit = false))
                            }, {
                              default: _withId(() => [
                                _hoisted_32
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_33, [
                    _createVNode("p", null, [
                      _createVNode("b", null, _toDisplayString("版本号: " +
                    _ctx.new_report.new_version +
                    " - " +
                    "时间: " +
                    _ctx.new_report.create_date), 1)
                    ]),
                    _createVNode("div", _hoisted_34, [
                      (
                    !_ctx.get_is_super &&
                    (_ctx.localProject === 34 ||
                      _ctx.localProject === 12 ||
                      _ctx.localProject === 47 ||
                      _ctx.localProject === 32 ||
                      _ctx.localProject === 35 ||
                      _ctx.localProject === 9 ||
                      _ctx.localProject === 36 ||
                      _ctx.localProject === 40)
                  )
                        ? (_openBlock(), _createBlock(_component_el_form, {
                            key: 0,
                            inline: true,
                            model: _ctx.copyVal,
                            size: "mini"
                          }, {
                            default: _withId(() => [
                              (_ctx.new_report.task_record_id != null)
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 0,
                                    label: "当前记录id:",
                                    class: "iTemWidth2"
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(_ctx.new_report.task_record_id), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_form_item, {
                                label: "任务记录id",
                                class: "iTemWidth"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    onChange: _ctx.equipmentUpdate,
                                    modelValue: _ctx.copyVal.taskRecordId,
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.copyVal.taskRecordId = $event)),
                                    placeholder: "请选择任务记录id",
                                    filterable: ""
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.TaskRecordQuery, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.id,
                                          label: item.id,
                                          value: item.id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, {
                                label: "设备数据",
                                class: "iTemWidth"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.copyVal.deviceVal,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.copyVal.deviceVal = $event)),
                                    placeholder: "请选择设备数据",
                                    filterable: ""
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.TaskRecordDevices, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.id,
                                          label: item.model.model,
                                          value: item.id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_popconfirm, {
                                    title: "确认复制数据吗？",
                                    onConfirm: _ctx.CopyBtn,
                                    placement: "top"
                                  }, {
                                    reference: _withId(() => [
                                      _createVNode(_component_el_button, {
                                        type: "primary",
                                        disabled: _ctx.interfaceDisabled
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_35
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]),
                                    _: 1
                                  }, 8, ["onConfirm"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["model"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_36, [
                    (
                  _ctx.localProject !== 34 &&
                  _ctx.localProject !== 40 &&
                  _ctx.localProject !== 47
                )
                      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_37, [
                          _hoisted_38
                        ], 512)), [
                          [_directive_loading, _ctx.loading]
                        ])
                      : _createCommentVNode("", true),
                    (
                  _ctx.localProject === 34 ||
                  _ctx.localProject === 40 ||
                  _ctx.localProject === 40
                )
                      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_39, [
                          _hoisted_40
                        ], 512)), [
                          [_directive_loading, _ctx.loading]
                        ])
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_41, [
                      _withDirectives(_createVNode("table", _hoisted_42, [
                        _createVNode("tr", null, [
                          _createVNode("td", _hoisted_43, [
                            _createVNode("img", {
                              src: _ctx.get_skin_data.project.icon
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("td", _hoisted_44, " 【" + _toDisplayString(_ctx.get_skin_data.project.project_name) + "】 ", 1)
                        ]),
                        _createVNode("tr", null, [
                          _createVNode("td", null, [
                            _hoisted_45,
                            _createVNode("span", null, _toDisplayString(_ctx.get_skin_data.base.version), 1)
                          ]),
                          _createVNode("td", null, [
                            _hoisted_46,
                            _createVNode("span", null, _toDisplayString(_ctx.get_skin_data.base.date), 1)
                          ]),
                          _createVNode("td", null, [
                            _hoisted_47,
                            _createVNode("span", null, _toDisplayString(_ctx.get_skin_data.base.creator), 1)
                          ])
                        ]),
                        _createVNode("tr", null, [
                          _createVNode("td", null, [
                            _hoisted_48,
                            _createVNode("span", null, [
                              _createVNode("b", null, _toDisplayString(_ctx.get_skin_data.base.skin_num), 1)
                            ])
                          ]),
                          _hoisted_49,
                          _hoisted_50
                        ])
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ])
                    ]),
                    _createVNode("div", _hoisted_51, [
                      _hoisted_52,
                      _hoisted_53,
                      _createVNode("ul", null, [
                        _createVNode("li", null, " 自动化遍历王者荣耀海外版本" + _toDisplayString(_ctx.get_skin_data.base.skin_num) + "款皮肤,采集每款皮肤进场动画和idle动画的性能数据 ", 1),
                        _hoisted_54
                      ]),
                      _hoisted_55,
                      _createVNode("table", _hoisted_56, [
                        _hoisted_57,
                        _createVNode("tbody", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_skin_data.device_list, (item, index) => {
                            return (_openBlock(), _createBlock("tr", { key: index }, [
                              _createVNode("td", null, _toDisplayString(item.level), 1),
                              _createVNode("td", null, _toDisplayString(item.model), 1),
                              _createVNode("td", null, _toDisplayString(item.os), 1),
                              _createVNode("td", null, _toDisplayString(item.frame_rate), 1),
                              _createVNode("td", null, _toDisplayString(item.resolution), 1),
                              _createVNode("td", null, _toDisplayString(item.camera_height), 1),
                              _createVNode("td", null, _toDisplayString(item.render), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _hoisted_58,
                    _hoisted_59,
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_skin_data.model_list, (value, key, index) => {
                      return (_openBlock(), _createBlock("div", {
                        style: {"margin-top":"8px"},
                        key: index
                      }, [
                        _createVNode("h6", _hoisted_60, [
                          _hoisted_61,
                          _createTextVNode(" " + _toDisplayString(key), 1)
                        ]),
                        _createVNode("p", null, [
                          _hoisted_62,
                          _createVNode("a", {
                            target: "_blank",
                            href: value.url
                          }, _toDisplayString(value.url), 9, ["href"])
                        ]),
                        _createVNode("table", _hoisted_63, [
                          _createVNode("thead", _hoisted_64, [
                            _createVNode("tr", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.gameList, (item) => {
                                return (_openBlock(), _createBlock("td", { key: item }, _toDisplayString(item), 1))
                              }), 128))
                            ])
                          ]),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(value.data, (item, k) => {
                            return (_openBlock(), _createBlock("tbody", { key: k }, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item, (v, i) => {
                                return (_openBlock(), _createBlock("tr", { key: i }, [
                                  (i === 0)
                                    ? (_openBlock(), _createBlock("td", {
                                        key: 0,
                                        rowspan: item.length
                                      }, _toDisplayString(k), 9, ["rowspan"]))
                                    : _createCommentVNode("", true),
                                  (i === 0)
                                    ? (_openBlock(), _createBlock("td", {
                                        key: 1,
                                        rowspan: item.length
                                      }, _toDisplayString(v.hero_name), 9, ["rowspan"]))
                                    : _createCommentVNode("", true),
                                  (i === 0)
                                    ? (_openBlock(), _createBlock("td", {
                                        key: 2,
                                        rowspan: item.length
                                      }, _toDisplayString(v.skin_name), 9, ["rowspan"]))
                                    : _createCommentVNode("", true),
                                  _createVNode("td", null, _toDisplayString(v.action), 1),
                                  _createVNode("td", null, _toDisplayString(v.animation_duration), 1),
                                  _createVNode("td", null, [
                                    _createVNode("span", {
                                      style: 'color:' + _ctx.getAvg_fps(v)
                                    }, _toDisplayString(v.avg_fps), 5)
                                  ]),
                                  _createVNode("td", null, _toDisplayString(v.var_fps), 1),
                                  _createVNode("td", null, _toDisplayString(v.fps_lt_18_pcnt), 1),
                                  _createVNode("td", null, _toDisplayString(v.fps_lt_20_pcnt), 1),
                                  _createVNode("td", null, _toDisplayString(v.min_fps), 1),
                                  _createVNode("td", null, _toDisplayString(v.avg_cpu), 1),
                                  _createVNode("td", null, _toDisplayString(v.avg_pss), 1),
                                  _createVNode("td", null, _toDisplayString(v.max_pss), 1),
                                  _createVNode("td", null, _toDisplayString(v.max_vss), 1),
                                  _createVNode("td", null, _toDisplayString(v.avg_vss), 1),
                                  _createVNode("td", null, [
                                    _createVNode("a", {
                                      target: "_blank",
                                      href: _ctx.get_url(v.url)
                                    }, "链接", 8, ["href"]),
                                    _createVNode("i", {
                                      onClick: ($event: any) => (_ctx.btn(v.url)),
                                      class: "el-icon-document-copy"
                                    }, null, 8, ["onClick"])
                                  ])
                                ]))
                              }), 128))
                            ]))
                          }), 128))
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _hoisted_65
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})